import Div from "./Div"
import FormButton from "./FormButton"
import { createPortal } from "react-dom"
import Input from "./Input";
import Form from "./Form";
import { useState } from "react";
import { addGoogleLicense } from "../http/AddLicenseHttp";


export function GoogleAddLicenseModal({ updateState, domain_name, googleLicense, handleClicked, ...props }) {

    const [addedSeats, setAddedSeats] = useState(0)
    const [error, setError] = useState();

    function handleClose() {
        handleClicked(false);
    }

    function handleChangeSeats(event) {
       setAddedSeats(event.target.value)
    }

    async function handleGoogleAddLicense(event){
        event.preventDefault();

        if(googleLicense.seats < 0){
            setError('Seat Reduction not Allowed')
        }
        else{
            //   console.log(googleLicense.subscription, googleLicense.customer_id,googleLicense.seats,
            //      googleLicense.plan, addedSeats)
            const googleAddLicenseResponse =  await addGoogleLicense(googleLicense.domain_name, 
            googleLicense.subscription, googleLicense.customer_id, googleLicense.seats,
             googleLicense.plan, addedSeats)
            console.log(googleAddLicenseResponse)
            // console.log(googleLicense.subscription, googleLicense.customer_id,googleLicense.seats,
            //      googleLicense.plan, addedSeats)
            if (!googleAddLicenseResponse){
                alert("Failed to add License")
            } 
            else{
                alert("License Added Successfully")
            }
        }
    }

    return (
        <>
            {createPortal(

                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', width:'45%' }}>

                        <Div className="form-group">
                            Add License for {googleLicense.domain_name}

                        </Div>
                        <Div>
                            <Form onSubmit={handleGoogleAddLicense}>
                                <Div className="form-group">
                                    <Input value={googleLicense.subscription} type="text" className="form-control" disabled />
                                </Div>
                                <Div className="form-group">
                                    <Input value={googleLicense.domain_name} type="text" className="form-control" disabled />
                                </Div>
                                <Div className="form-group">
                                    <Input value={googleLicense.seats} type="text" name='seats' className="form-control" disabled/>
                                </Div>
                                <Div className="form-group">
                                    <Input value={addedSeats} type="text" name='addSeats' className="form-control" onChange={handleChangeSeats} />
                                </Div>
                                <Div className='row'>
                                    <Div className='col-sm-6'>
                                        < FormButton type='submit' className="btn btn-primary submit-btn btn-block" >
                                            Add License </FormButton>
                                    </Div>
                                    <Div className='col-sm-6'>
                                        < FormButton type='button' onClick={handleClose} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                    </Div>
                                    {error ? <p style={{color:'red'}}>{error}</p>: null}
                                </Div>
                            </Form>

                        </Div>
                        {/* {googleLicense !== false ?


                            googleLicense.domains.subscriptions.map((subscription) =>
                                <>
                                    <tr key={subscription.subscriptionId}>
                                        <td>{subscription.skuName}</td>
                                        <td>{subscription.plan.planName}</td>
                                        <td>{subscription.status}</td>
                                        {subscription.plan.planName !== 'FREE' ?
                                            <>
                                                <td>{subscription.seats.licensedNumberOfSeats}</td>
                                                <td>{subscription.seats.maximumNumberOfSeats}</td>
                                            </>
                                            : <td></td>}
                                        {subscription.plan.planName !== 'FLEXIBLE' ?
                                            <td>{subscription.seats.numberOfSeats}</td> :
                                            <td></td>
                                        }
                                        <td>
                                            <button onClick={() => handleGoogleAddLicense(subscription)}>Add License</button>
                                        </td>
                                    </tr>

                                </>
                            ) : null} */}

                    </dialog >

                </Div >
                , document.getElementById('modal'))

            }
        </>
    )

}